import axiosInstance from './axiosInstance';

// 🔹 Login: Enviar credenciales y recibir token + usuario + menú
export const loginUser = async ({ NomUsu, Pas }) => {
  const response = await axiosInstance.post('/auth/login', { NomUsu, Pas });
  return response.data; // { token, user, menu }
};

// 🔹 Logout: Solo limpiamos localStorage y el estado global
export const logoutUser = async () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('menu');
  return null;
};

// 🔹 Obtener el menú dinámico después del login
export const fetchMenu = async () => {
  const response = await axiosInstance.get('/menu');
  return response.data;
};